import React, { useState } from "react";
import { PageTitle } from "../../../components/style";
import { Boxed } from "../../../components/Boxed.components";
import { Button } from "../../../components/Button.components";
import { Grid } from "../../../components/Grid.components";
import {
  AsyncSelect,
  Input,
  InputDate,
  SimpleSelect,
} from "../../../components/Input.components";
import { Uploader } from "../../../components/Uploader.components";
import { Text } from "../../../components/Text.components";
import { SwitchComp } from "../../../components/Switch.components";

export const ViewCompany = (props) => {
  // State props
  const { singleCompanyData } = props;
  // Dispatch props
  const { form, editCompany, redirect } = props;

  console.log(singleCompanyData);

  const { getFieldProps, getFieldError, validateFields, getFieldValue } = form;
  const [profileImage, setProfileImage] = useState("");

  const [showUploader, setShowUploader] = useState(false);
  const [companyStatus, setCompanyStatus] = useState(
    singleCompanyData?.status === "active" ? true : false
  );

  const addImage = (e) => {
    const base64Image = `data:${e.type};base64,${e.base64}`;
    // const payload = {
    //   companyLogoUrl: base64Image
    // }
    setProfileImage(base64Image);
    setShowUploader(false);
    // editCompany({data: payload, id: singleCompanyData?._id });
  };

  const onSubmit = () => {
    validateFields((error, value) => {
      if (!error) {
        const payload = {
          name: value.companyname.trim(),
          address: value.companyaddress.trim(),
          email: value.companyemail.trim(),
          status: companyStatus === true ? "active" : "inactive",
          contactPerson: {
            name: value.contactname.trim(),
            email: value.contactemail.trim(),
            phone: value.contactphone.trim(),
            secondaryEmail: value.contactemail2.trim(),
          },
        };
        console.log(payload);
        editCompany({ data: payload, id: singleCompanyData?._id });
      }
    });
  };
  return (
    <Boxed pad="30px">
      <Boxed display="flex" alignItems="center" justifyContent="space-between">
        <PageTitle margin="5px 0">View Company</PageTitle>

        <i className="icon-cancel" onClick={() => redirect("/companies")} style={{cursor: 'pointer'}} />
      </Boxed>

      {!showUploader && (
        <Boxed
          margin="10px auto"
          display="flex"
          flexDirection="column"
          alignItems="center"
          position="relative"
        >
          <img
            src={profileImage || singleCompanyData?.companyLogoUrl}
            alt="profile"
            style={{ width: "160px", height: "160px", borderRadius: "9999px" }}
          />
          <Boxed
            bColor="#ffff"
            pad="5px 8px"
            borderRadius="9999px"
            position="absolute"
            bottom="24px"
            onClick={() => setShowUploader(true)}
          >
            <i className="icon-edit-2" style={{ fontSize: "22px" }} />
          </Boxed>
        </Boxed>
      )}

      <Boxed
        margin="10px auto"
        display="flex"
        flexDirection="column"
        alignItems="flex-end"
      >
        <Button onClick={onSubmit}>Edit</Button>
      </Boxed>

      {showUploader && (
        <Boxed margin="15px">
          <Text fontWeight={800}>Add Company Logo</Text>
          <Uploader
            types={["image/png", "image/jpeg"]}
            message={"Click to add a profile image"}
            callBack={addImage}
          />
        </Boxed>
      )}
      <Grid
        desktop="repeat(2, 1fr)"
        tablet="repeat(2, 1fr)"
        mobile="repeat(1,1fr)"
        pad="0 0 30px 0"
      >
        <Boxed pad="10px 0">
          <Input
            type="text"
            label="Company Name"
            placeholder="Enter first name..."
            error={
              getFieldError("companyname") ? "First name is required" : null
            }
            {...getFieldProps("companyname", {
              initialValue: singleCompanyData?.name,
              rules: [{ required: true }],
            })}
          />
        </Boxed>
        <Boxed pad="10px 0">
          <Input
            type="text"
            label="Company Email"
            placeholder="Enter Company email..."
            error={
              getFieldError("companyemail") ? "Company Email is required" : null
            }
            {...getFieldProps("companyemail", {
              initialValue: singleCompanyData?.email,
              rules: [{ required: true, email: true }],
            })}
          />
        </Boxed>
        <Boxed pad="10px 0">
          <Input
            type="text"
            label="Company Address"
            placeholder="Enter Company Address..."
            error={
              getFieldError("companyaddress")
                ? "Company Address is required"
                : null
            }
            {...getFieldProps("companyaddress", {
              initialValue: singleCompanyData?.address,
              rules: [{ required: true }],
            })}
          />
        </Boxed>
        <Boxed pad="10px 0">
          <Input
            type="text"
            label="Contact Name"
            placeholder="Enter Contact name..."
            error={
              getFieldError("contactname") ? "Contact name is required" : null
            }
            {...getFieldProps("contactname", {
              initialValue: singleCompanyData?.contactPerson?.name,
              rules: [{ required: true }],
            })}
          />
        </Boxed>

        <Boxed pad="10px 0">
          <Input
            type="text"
            label="Contact Email"
            placeholder="Enter Contact email..."
            error={
              getFieldError("contactemail") ? "Contact Email is required" : null
            }
            {...getFieldProps("contactemail", {
              initialValue: singleCompanyData?.contactPerson?.email,
              rules: [{ required: true, email: true }],
            })}
          />
        </Boxed>
        <Boxed pad="10px 0">
          <Input
            type="text"
            label="Secondary Contact Email"
            placeholder="Enter Contact email..."
            error={
              getFieldError("contactemail2")
                ? "Contact Email is required"
                : null
            }
            {...getFieldProps("contactemail2", {
              initialValue: singleCompanyData?.contactPerson?.email,
              rules: [{ required: false, email: true }],
            })}
          />
        </Boxed>
        <Boxed pad="10px 0">
          <Input
            type="text"
            label="Contact Phone Number"
            placeholder="Enter Contact Phone Number..."
            error={
              getFieldError("contactphone") ? "Contact Email is required" : null
            }
            {...getFieldProps("contactphone", {
              initialValue: singleCompanyData?.contactPerson?.phone?.phone,
              rules: [{ required: true }],
            })}
          />
        </Boxed>
        <Boxed pad="10px 0">
          <Input
            type="text"
            label="Created Date"
            disabled
            placeholder="Enter phone number..."
            error={
              getFieldError("createdDate") ? "Phone number is required" : null
            }
            {...getFieldProps("createdDate", {
              initialValue: singleCompanyData?.createdAt.slice(0, 10),
              rules: [{ required: true }],
            })}
          />
        </Boxed>
        <Boxed pad="10px 0">
          <Input
            type="text"
            label="Subscription Plan"
            disabled
            placeholder="Enter phone number..."
            error={getFieldError("plan") ? "Phone number is required" : null}
            {...getFieldProps("plan", {
              initialValue: singleCompanyData?.subscriptionPlan,
              rules: [{ required: true }],
            })}
          />
        </Boxed>
        <Boxed pad="15px 0" display="flex" alignItems="center" margin="10px">
          <Text fontWeight={600} margin="0 5px">
            Status:
          </Text>
          <SwitchComp
            checked={companyStatus}
            onChange={() => setCompanyStatus(!companyStatus)}
          />
        </Boxed>
      </Grid>
    </Boxed>
  );
};
